export default "__VITE_ASSET__LlkwP5AqLzn2qlmmC5jEtA__"